//Contributors.jsx

import React, { useEffect} from "react";
import '../styles/teamReveal.css';

import meet from './Images/Meet Oza.jpg';
import kunal from './Images/KUNAL SURYAWANSHI.jpg';
import nikhil from './Images/Nikhil Jumbad.jpg';
import haamid from './Images/HAAMID SYED.png';
import aaryan from './Images/Aaryan Gupta.jpeg';
import isha from './Images/ISHA  VARADE.jpg';
import aditee from './Images/ADITEE MOHANTY.jpeg';
import apurva from './Images/Apurva Dabhade.jpg';
import archit from './Images/ARCHIT GUPTA.jpg';
import tanish from './Images/Tanish_Kulkarni.jpg';
import vedant from './Images/Vedant Ahire_GFG.jpg';
import UserNav from "./UserNav";


const Contributors = ()=>{

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return(<>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"></link>
        
    

<UserNav/>
<div className="heading">
<h1>Web Developers</h1></div>
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={kunal} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Kunal Suryawanshi</h1>
    <p>Project Lead <br/>MERN Stack Developer</p>
    
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/kunal-suryawanshi-943827259"><i className="fab fa-linkedin"></i></a>
        
        <a href="https://www.instagram.com/kunalsuryawanshi999"><i className="fab fa-instagram"></i></a>
    </div>
</div>

<div className="card-container">

<div className="card">
        <div className="top-semi-circle"></div>
        <div className="outer-circle">
            <div className="inner-circle">
                <img src={meet} alt="Yash Gupta"/>
            </div>
        </div>
        <h1>Meet Oza</h1>
        <p>MERN Stack Developer</p>
        <div className="social-bar">
            <a href="http://linkedin.com/in/meetoza30"><i className="fab fa-linkedin"></i></a>
          
            <a href="http://instagram.com/meetoza30"><i className="fab fa-instagram"></i></a>
        </div>
    </div>

<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={haamid} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Haamid Syed</h1>
    <p>MERN Stack Developer</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/haamid-syed-1584a3311?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
       
        <a href="https://www.instagram.com/haamid.fr?igsh=eDNqMXo2eXhycDZn"><i className="fab fa-instagram"></i></a>
    </div>
</div>
    
<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={vedant} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Vedant Ahire</h1>
    <p>Technical Associate</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/vedant-ahire-067220245/"><i className="fab fa-linkedin"></i></a>
       
        <a href="https://www.instagram.com/vedantahire05/"><i className="fab fa-instagram"></i></a>
    </div>
</div>

<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={nikhil} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Nikhil Jumbad</h1>
    <p>MERN Stack Developer</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/nikhil-jumbad/"><i className="fab fa-linkedin"></i></a>
      
        <a href="https://www.instagram.com/nikhilj_005?igsh=bHBheGFlajFlbTN4"><i className="fab fa-instagram"></i></a>
    </div>
</div>


<div className="card">
    <div className="top-semi-circle"></div>
    <div className="outer-circle">
        <div className="inner-circle">
            <img src={aaryan} alt="Yash Gupta"/>
        </div>
    </div>
    <h1>Aaryan Gupta</h1>
    <p>MERN Stack Developer</p>
    <div className="social-bar">
        <a href="https://www.linkedin.com/in/aaryan-gupta-9b1a00295?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><i className="fab fa-linkedin"></i></a>
        
        <a href="https://www.instagram.com/aaryyan_g?igsh=MTd4aDl0bW9rd2I5OQ%3D%3D&utm_source=qr"><i className="fab fa-instagram"></i></a>
    </div>
</div>
</div>




    
        
    


        <div className="heading">
            <h1 >Web Designers</h1></div>
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={isha} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Isha Varade</h1>
                
                <p>Design Lead <br/>UI/UX Designer</p>
                
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/isha-varade-0191a22aa?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                    
                    <a href="https://www.instagram.com/isha__varade/"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            
        <div className="card-container">
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={aditee} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Aditee Mohanty </h1>
                <p>UI/UX Designer</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/aditee-mohanty-1471bb293/"><i className="fab fa-linkedin"></i></a>
                  
                    <a href="https://www.instagram.com/aditee_mohanty?igsh=MXhkNHJwdWlxb3Q0aQ=="><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={apurva} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Apurva Dabhade</h1>
                <p>UI/UX Designer</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/apurva-dabhade-14969a295/"><i className="fab fa-linkedin"></i></a>
                   
                    <a href="https://www.instagram.com/apurvadabhade?igsh=NmdveW1zanc2dnox"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={archit} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Archit gupta</h1>
                <p>UI/UX Designer</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/archit-gupta-77b287251/"><i className="fab fa-linkedin"></i></a>
                    
                    <a href="https://www.instagram.com/__architgupta_/"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            <div className="card">
                <div className="top-semi-circle"></div>
                <div className="outer-circle">
                    <div className="inner-circle">
                        <img src={tanish} alt="Yash Gupta"/>
                    </div>
                </div>
                <h1>Tanish Kulkarni</h1>
                <p>UI/UX Designer</p>
                <div className="social-bar">
                    <a href="https://www.linkedin.com/in/tanish-kulkarni-190440304?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i className="fab fa-linkedin"></i></a>
                    
                    <a href="https://www.instagram.com/coolkarni_tanish005?utm_source=qr&igsh=OWdjNXljeDZidThn"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
            </div>


            
                                        
    </>)
}

export default Contributors;
